require('../../modules/es6.object.is');
module.exports = require('../../modules/_core').Object.is;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/object/is.js
// module id = 156
// module chunks = 2